import { render, staticRenderFns } from "./coachNewModeJoin.vue?vue&type=template&id=159b64c3&scoped=true&"
import script from "./coachNewModeJoin.vue?vue&type=script&lang=js&"
export * from "./coachNewModeJoin.vue?vue&type=script&lang=js&"
import style0 from "./coachNewModeJoin.vue?vue&type=style&index=0&id=159b64c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b64c3",
  null
  
)

export default component.exports